var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOopsSelf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5025 38.1297C29.3454 38.5112 28.9721 38.76 28.56 38.76H26.52H24.48H22.44C22.0279 38.76 21.6546 38.5111 21.4975 38.1297C21.3404 37.7482 21.4282 37.3096 21.7198 37.0178L23.4599 35.2778V23.8822L21.7198 22.1401C21.4281 21.8483 21.3404 21.4097 21.4975 21.0282C21.6546 20.6467 22.0279 20.3999 22.44 20.3999H24.48H25.5H26.52C27.083 20.3999 27.54 20.8548 27.54 21.4199V35.2777L29.2822 37.0177C29.5718 37.3096 29.6596 37.7482 29.5025 38.1297ZM25.5 12.24C27.1871 12.24 28.56 13.6109 28.56 15.3C28.56 16.9871 27.1871 18.36 25.5 18.36C23.8129 18.36 22.44 16.9871 22.44 15.3C22.44 13.6109 23.8129 12.24 25.5 12.24ZM25.5 0C11.4403 0 0 11.4382 0 25.5C0 39.5597 11.4403 51 25.5 51C39.5618 51 51 39.5597 51 25.5C51 11.4382 39.5618 0 25.5 0Z",
    fill: "#B58AFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOopsSelf);
export default __webpack_public_path__ + "static/media/oopsSelf.cb4234e6b40e5ca96bc9702a25de9701.svg";
export { ForwardRef as ReactComponent };